import { PremierServiceTypeDTO } from "../DTO/premierServiceTypeDTO";

export class PremierServiceType{
    public id!: string;
    public name!: string;

    public static mapFromDTO(param:PremierServiceTypeDTO):PremierServiceType{
        if(!param) throw new Error("parameter is null");
        let obj = new PremierServiceType();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:PremierServiceType):PremierServiceTypeDTO{
        if(!param) throw new Error("parameter is null");
        let dto = new PremierServiceTypeDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}